import React from 'react';
import PatientsView from '../components/List/patientsList';

export default function PatientsList() {
  
    return (
        <>
            <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#263238]">Patients</h2>
            <div className="bg-white h-[calc(100vh-180px)] overflow-y-hidden rounded-md">
                <PatientsView/>
            </div>
        </>
    )
}
    